export default "__VITE_ASSET__DOt92qGs__"